import { Calendar as CalendarIcon, MessageSquare, CheckSquare, Play, User } from "lucide-react";

export default function CardItem({ card, onClick, onDragStart, onDragEnd, isDragging }) {
  const checklistTotal = (card.checklist || []).length;
  const checklistDone = (card.checklist || []).filter((c) => c.done).length;
  const today = new Date().toISOString().split('T')[0];

  return (
    <div
      draggable
      onDragStart={(e) => onDragStart(e, card)}
      onDragEnd={onDragEnd}
      onClick={onClick}
      className={`kanban-card group bg-white dark:bg-zinc-950 border border-zinc-200 dark:border-zinc-800 p-4 cursor-grab hover:border-black dark:hover:border-white transition-colors ${
        isDragging ? "is-dragging" : ""
      }`}
      data-testid={`kanban-card-${card.id}`}
    >
      {card.labels && card.labels.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-3">
          {card.labels.map((l) => (
            <span
              key={l}
              className="px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider border border-zinc-900 dark:border-zinc-100 text-zinc-900 dark:text-zinc-100"
            >
              {l}
            </span>
          ))}
        </div>
      )}
      <div className="text-sm font-medium text-zinc-950 dark:text-zinc-100 leading-snug">{card.title}</div>
      {(card.due_date || card.start_date || checklistTotal > 0 || card.description || card.created_by_name) && (
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-3 text-xs text-zinc-500">
          {card.start_date && (
            <span className={`inline-flex items-center gap-1 ${card.start_date <= today ? 'text-green-600 dark:text-green-400' : ''}`} data-testid={`card-${card.id}-start-date`}>
              <Play className="h-3 w-3" />
              {new Date(card.start_date + 'T00:00:00').toLocaleDateString(undefined, {
                month: "short",
                day: "numeric",
              })}
            </span>
          )}
          {card.due_date && (
            <span className="inline-flex items-center gap-1" data-testid={`card-${card.id}-due-date`}>
              <CalendarIcon className="h-3 w-3" />
              {new Date(card.due_date).toLocaleDateString(undefined, {
                month: "short",
                day: "numeric",
              })}
            </span>
          )}
          {card.created_by_name && (
            <span className="inline-flex items-center gap-1" title={card.created_by_name}>
              <User className="h-3 w-3" />
              {card.created_by_name.split(' ')[0]}
            </span>
          )}
          {checklistTotal > 0 && (
            <span className="inline-flex items-center gap-1">
              <CheckSquare className="h-3 w-3" />
              {checklistDone}/{checklistTotal}
            </span>
          )}
          {card.description && (
            <span className="inline-flex items-center gap-1">
              <MessageSquare className="h-3 w-3" />
            </span>
          )}
        </div>
      )}
    </div>
  );
}
